import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Box, Container, Grid, Typography } from '@mui/material';
import MailIcon from '@mui/icons-material/Mail';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import YouTubeIcon from '@mui/icons-material/YouTube';
import SpotifyIcon from '../Icons/SpotifyIcon';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import logoFooter from '../../assets/logo-footer.png';

const Footer = () => {
  const [currentDomain, setCurrentDomain] = useState('cl'); // Default to Chile
  
  useEffect(() => {
    const hostname = window.location.hostname;
    if (hostname.endsWith('.cl')) {
      setCurrentDomain('cl');
    } else if (hostname.endsWith('.es')) {
      setCurrentDomain('es');
    } else {
      setCurrentDomain('cl');
    }
  }, []);

  const whatsappConfig = {
    cl: {
      title: <><WhatsAppIcon sx={{ mr: 1, color: '#ff5722' }} /> +56 9 6822 4080</>,
      path: "https://wa.me/56968224080"
    },
    es: {
      title: <><WhatsAppIcon sx={{ mr: 1, color: '#ff5722' }} /> +34 617 59 84 63</>,
      path: "https://wa.me/34617598463"
    }
  };
  
  // Crear directamente el array de enlaces con el WhatsApp correspondiente
  const about = [
    {
      title: "www.jeshua.cl",
      path: "https://www.jeshua.cl"
    },
    {
      title: "www.jeshua.es",
      path: "https://www.jeshua.es"
    },
    {
      title: <><MailIcon sx={{ mr: 1, color: '#ff5722' }} /> contacto@jeshua.ong</>,
      path: "mailto:contacto@jeshua.ong"
    },
    // WhatsApp según el dominio - insertado directamente
    whatsappConfig[currentDomain],
    {
      title: <><YouTubeIcon sx={{ mr: 1, color: '#ff5722' }} /> YouTube</>,
      path: "https://www.youtube.com/@jeshua.ben.joseph"
    },
    {
      title: <><SpotifyIcon sx={{ mr: 1, color: '#ff5722' }} /> Spotify</>,
      path: "https://open.spotify.com/user/312xoy3j3h7iokeaybo6ljdopt3u"
    }
  ];
  const interestLinks = [
    {
      title: "Trabajadores de la luz",
      path: "/trabajadores-de-la-luz"
    },
    {
      title: "Jeshua",
      path: "/esenios-jeshua"
    },
    {
      title: "María Madre",
      path: "/esenios-maria-madre"
    },
    {
      title: "María Magdalena",
      path: "/esenios-maria-magdalena"
    },
    {
      title: "Gaia",
      path: "/gaia"
    },
    {
      title: "Ángeles",
      path: "/angeles-y-arcangeles/angeles"
    }
  ];

  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: 'background.paper',
        py: 6,
        mt: 'auto',
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          <Grid 
            item 
            xs={12} 
            md={4}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: { xs: 'center', md: 'flex-start' }
            }}
          >
            <Box
              component="img"
              src={logoFooter}
              alt="Jeshua Logo"
              sx={{
                height: '200px',
                width: 'auto',
                mb: 2,
                cursor: 'pointer',
                '&:hover': {
                  opacity: 0.9
                }
              }}
              onClick={() => window.location.href = '/'}
            />
          </Grid>
          
          <Grid item xs={12} md={4}>
            <Typography variant="h6" gutterBottom color="#ff5722">
              NOSOTROS
            </Typography>
            {
              about.map((link, index) => (
                <Link
                  to={link.path} 
                  key={index}
                  style={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    mb: 1,
                    color: 'white',
                    textDecoration: 'none',
                    '&:hover': {
                      textDecoration: 'underline'
                    }
                  }}
                >
                  {link.title}
                </Link>
              ))
            }
          </Grid>
          <Grid item xs={12} md={4}>
            <Typography variant="h6" gutterBottom color="#ff5722">
              ENLACES R&Aacute;PIDOS
            </Typography>
            {interestLinks.map((link, index) => (
              <Link 
                to={link.path}
                key={index}
                style={{ 
                  display: 'block', 
                  mb: 1,
                  color: 'white',
                  textDecoration: 'none',
                  '&:hover': {
                    textDecoration: 'underline'
                  }
                }}
              >
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <DoneAllIcon sx={{ mr: 1, fontSize: 'small', color: 'white' }} />
                  {link.title}
                </Box>
              </Link>
            ))}
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default Footer;